export default __webpack_public_path__ + "static/media/slide1.b362f4c9.png";